import ChangePassword from '../../../../components/Auth/ChangePassword';
import '../FindAuthForm.css';
import '../find.css';

const ChangePasswordPage = () => {
    return (
        <div className="findPage">
            <ChangePassword />
        </div>
    );
};

export default ChangePasswordPage;
